module.exports = __webpack_public_path__ + "img/内容@2x.d6beaf85.png";